export const isEmailValid = (email: string) =>
  email === '' ||
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
    email
  );

export const isValidDateTimeString: Record<'12h' | '24h', RegExp> = {
  '12h': /^(((0[1-9])|(1[0-2])):([0-5])(0|5)\s(A|P|a|p)(M|m))$/,
  '24h': /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
};

export const valueIsArray = (value: any): boolean => {
  return typeof value === 'object' && value !== null && Array.isArray(value);
};

export const valueIsObject = (value: any): boolean => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const isValidPhoneNumber = (phone: string) =>
  !phone ? true : /^\d{10}$/.test(phone);

export const isValidIpAddress = (ip: string | undefined) =>
  !ip ? true : /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/.test(ip);

export const isValidMacAddress = (mac: string): ValidationResult => {
  let macAddress = mac.replace(/:*-*/g, '');
  const macPattern = /(([0-9A-F]){2}){6}/gi;

  const result = macPattern.test(macAddress);
  return {
    isValid: result,
    message: !result ? 'Invalid MAC Address' : undefined,
  };
};

export const isValidGuid = (guid: string): ValidationResult => {
  const guidPattern =
    /^(?!00000000-0000-0000-0000-000000000000)\{?[0-9A-Fa-f]{8}-(?:[0-9A-Fa-f]{4}-){3}[0-9A-Fa-f]{12}}?$/i;

  if (guid.length < 36)
    return {
      isValid: false,
      message: 'GUID must be 36 characters in length',
    };

  const result = guidPattern.test(guid);
  return {
    isValid: result,
    message: !result ? 'Invalid GUID' : undefined,
  };
};

export const isValidString = (
  value?: string,
  options?: Partial<{ min: number; max: number }>
) => {
  if (!value) return false;
  const trimmedValue = value.trim();
  if (!options) return trimmedValue.length > 0;
  else
    return (
      trimmedValue.length >= (options.min ?? 0) &&
      trimmedValue.length <= (options.max ?? Infinity)
    );
};
